<template>
  <div class="select-bank-card">
    <!--顶部导航-->
    <Navbar title="选择银行卡" />
    <!--内容区域-->
    <div class="content">
      <!--银行卡列表-->
      <select-bank-card-list />
      <select-bank-card-list />
      <div class="foot-wrap">
        <div class="btn add-btn" @click="toBankCardBinding">
          <img src="@/assets/style/add-card-icon.png" alt="" />
          <span>添加银行卡</span>
        </div>
        <div class="btn confirm-btn" @click="confirmChangeBankCard">确定换卡</div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import selectBankCardList from "@/components/selectBankCard/selectBankCardList.vue";

export default {
  name: "SelectBankCard",
  components: {
    Navbar,
    selectBankCardList,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    toBankCardBinding() {
      this.$router.push({
        name: "bankCardBinding",
      });
    },
    confirmChangeBankCard() {
      
    }
  },
};
</script>

<style scoped lang="scss">
.select-bank-card {
}
.content {
  padding: 0 16px;
}
.foot-wrap {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn {
    width: 48%;
    height: 50px;
    border-radius: 12px;
    font-size: 18px;
    font-family: "Regular";
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .add-btn {
    background: #fff;
    color: #01abff;
    border: 1px solid #01abff;
  }
  .confirm-btn {
    background: #01abff;
    color: #fff;
  }
}
</style>
